import React, { useState } from 'react';

import { AnimatePresence } from 'framer-motion';

import { StyledReactMarkdown } from '@pkg/components';
import { IconWrapper } from '@pkg/components/Sections/Admin';
import { Sizes } from '@pkg/components/Sections/Profile/Buttons/Button/types';
import IconButton from '@pkg/components/Sections/Profile/IconButton';
import { ReactComponent as TrashIcon } from '@pkg/components/Sections/Profile/icons/trash-bin.svg';

import { RuleContent, RuleRemove, RuleTitle, RuleToggle, RuleWrapper } from './styles';
interface RuleProps {
    title: string;
    content: Array<string>;
    isEditView?: boolean;
    onDelete?: VoidFunction;
}

export const Rule = ({ title, content, onDelete, isEditView = false }: RuleProps) => {
    const [isExpanded, setIsExpanded] = useState(isEditView);

    const handleExpandClick = () => {
        setIsExpanded(!isExpanded);
    };

    const contentMarkup = content?.length
        ? content.map((item) => (
              <RuleContent
                  key={item}
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: 'auto', opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
              >
                  <StyledReactMarkdown>{item}</StyledReactMarkdown>
              </RuleContent>
          ))
        : null;

    return (
        <RuleWrapper>
            <RuleTitle $isExpanded={isExpanded} onClick={handleExpandClick}>
                {title}
                {isEditView && onDelete && (
                    <RuleRemove $isExpanded={isExpanded}>
                        <IconButton onClick={onDelete} size={Sizes.small}>
                            <IconWrapper>
                                <TrashIcon />
                            </IconWrapper>
                        </IconButton>
                    </RuleRemove>
                )}
                <RuleToggle $isExpanded={isExpanded} />
            </RuleTitle>
            <AnimatePresence initial={false}>{isExpanded && contentMarkup}</AnimatePresence>
        </RuleWrapper>
    );
};
